import { useQuery } from '@tanstack/react-query';

import { CoreBaseConfiguration } from './BaseConfiguration';
import { SystemBannersApi } from './core';

const SystemBannersApiKeys = {
  GET_SYSTEM_BANNER: 'system-banner',
};

const client = new SystemBannersApi(new CoreBaseConfiguration());

export const useGetActiveSystemBanner = () => {
  return useQuery({
    queryKey: [SystemBannersApiKeys.GET_SYSTEM_BANNER],
    queryFn: () => client.systemBannersGet(),
    retry: 0,
  });
};
